<template>
    <div>
        <div class="header">
          <div :style="{'padding-top': this.$route.params.NavBarHeight+'px', 'height': ((228 + this.$route.params.NavBarHeight) / 375) * 100% + 'px'}">
            <div class="header-line-1">
                <div>
                    <div id='player-name' v-html="player.playerName"></div>
                    <div class='sub-title-1'> </div>
                    <div class='sub-title-2'>
                        {{ player.birthday }} &nbsp;/&nbsp;{{ player.nationality }}
                    </div>
                    <div class='sub-title-2'>
                      <span>
                          {{ $t("playerIndex.height") }}/{{ $t("playerIndex.bodyWeight") }}&nbsp;{{ player.height }}/{{ player.weight }}
                      </span>
                      <span v-if="player.price > 0">
                          {{ $t("playerIndex.worth") }}&nbsp;{{ personalPrice }}
                      </span>
                    </div>
                </div>
                <playerAvatar id='avatar' :playerId='this.$route.params.playerId.toString()'/>
            </div>
            <div class="header-line-2">
              <div>
                  <div class='sub-title-3'>
                    {{ playerPosition[player.position] }}&nbsp;/&nbsp;{{ player.jerseyNumber }}{{ $t("playerIndex.numberName") }}
                  </div>
                  <div class='sub-title-1'>
                    {{ $t("playerIndex.playerPosition") }}&nbsp;/&nbsp;{{ $t("playerIndex.jerseyNumber") }}
                  </div>
              </div>
              <div>
                <div class='sub-title-3'>{{ player.team }}</div>
                <div class='sub-title-1'>{{ $t("playerInfo.playingTeam") }}</div>
              </div>
            </div>
          </div>
        </div>
    </div>
</template>

<script>
import playerAvatar from '@/components/PlayerAvatar'

export default {
  name: 'player',
  props: {
    player: {
      type: Object,
      require: false
    },
    playerName: {
      type: String
    }
  },
  components: {
    playerAvatar
  },
  data: function () {
    return {
      playerPosition: [
        this.$t('lineUp.forward'),
        this.$t('lineUp.centerForward'),
        this.$t('lineUp.guard'),
        this.$t('lineUp.goalkeeper')
      ]
    }
  },
  computed: {
    personalPrice: function () {
      var priceString = this.player.price.toString()
      var currencyIndex = parseInt(this.player.priceCurrency)
      var currencyString = ''
      switch (currencyIndex) {
        case 1:
          currencyString = this.$t('playerIndex.ouYuan')
          break
        case 2:
          currencyString = this.$t('playerIndex.meiYuan')
          break
        case 3:
          currencyString = this.$t('playerIndex.yingBang')
          break

        default:
          currencyString = this.$t('playerIndex.renMinBi')
          break
      }
      priceString = Math.abs(Number(priceString)) >= 1.0e+4
        ? Math.abs(Number(priceString)) / 1.0e+4 + this.$t('playerIndex.wan')
        : Math.abs(Number(priceString))
      return priceString + currencyString
    },
    routers: function () {
      return [
        [this.$t('playerIndex.playerInfo'), 'football-player-info', { ...this.$router.params, 'player': this.player }],
        [this.$t('playerIndex.playerStats'), 'football-player-stats', this.$router.params]
      ]
    }
  }
}
</script>

<style lang="sass" scoped>
@import '~@/styles'
.header
  background-size: cover
  background-image: url("~@/assets/player-bGb@2x.png")
  > div
    padding: 20+44px vw(20) vw(20) vw(20)

#avatar
  width: vw(70)
  height: vw(70)
  border-radius: vw(70)
  border: vw(2) solid #fafafa

.header-line-1
  display: flex
  justify-content: space-between
  margin-bottom: vw(20)

  div
    display: -webkit-box
    flex-direction: column

    div
      text-align: left

      &:nth-child(3)
        margin-bottom: vw(8)

  .sub-title-1
    margin-bottom: vw(12)

.header-line-2
  display: flex
  > div
    margin-right: vw(30)

#player-name
  font-size: vw(24)
  line-height: vw(24)
  color: white
  margin-bottom: vw(19)

%subTitleFont1
  font-size: vw(12)
  line-height: vw(12)

.sub-title-1
  @extend %subTitleFont1
  color: rgba(255, 255, 255, 0.75)

.sub-title-2
  @extend %subTitleFont1
  color: rgba(255, 255, 255, 0.4)

.sub-title-2 :nth-child(1)
  margin-right: vw(20)

.sub-title-3
  font-size: vw(18)
  line-height: vw(18)
  color: rgba(255, 255, 255, 0.4)
  margin-bottom: vw(5)

</style>
